import { api } from './api';

export const directoryService = {
    addDirectoryGroup: async (name, category, iconFile) => {
        const formData = new FormData();
        formData.append('groupName', name);
        formData.append('category', category);

        if (iconFile) {
            formData.append('groupIcon', iconFile);
        }

        return api.post('/directory-groups', formData);
    },

    getDirectoryGroups: async () => {
        return api.get('/directory-groups');
    },

    getDirectorySchemes: async (directoryId) => {
        return api.get(`/directory-schemes/${directoryId}`);
    },

    addDirectoryScheme: async (
        directoryId,
        title,
        description,
        redirectionLink,
        locationLink,
        mobile,
        location,
        image // Parameter kept for consistency, though currently unused in payload logic or dependent on backend
    ) => {
        const payload = {
            directoryId,
            title,
            description,
            redirectionLink,
            locationLink,
            mobile,
            location,
        };
        // Note: If image upload is needed for schemes, it would require FormData similar to addDirectoryGroup
        // Assuming JSON payload for now as per original web code, unless backend requires FormData for schemes too.
        return api.post('/directory-schemes', payload);
    },

    deleteDirectoryGroup: async (id) => {
        return api.delete(`/directory-groups/${id}`);
    },

    deleteDirectoryScheme: async (id) => {
        return api.delete(`/directory-schemes/${id}`);
    },

    updateDirectoryGroup: async (id, name, category, iconFile) => {
        const formData = new FormData();
        formData.append('groupName', name);
        formData.append('category', category);

        if (iconFile) {
            formData.append('groupIcon', iconFile);
        }

        return api.post(`/directory-groups/${id}`, formData);
    },

    updateDirectoryScheme: async (
        id,
        directoryId,
        title,
        description,
        redirectionLink,
        locationLink,
        mobile,
        location
    ) => {
        const payload = {
            directoryId,
            title,
            description,
            redirectionLink,
            locationLink,
            mobile,
            location,
        };

        return api.post(`/directory-schemes/${id}`, payload);
    }
};
